import { handleSliders } from '@/scripts/optional/advisory-board';

document.addEventListener('DOMContentLoaded', (): void => handleSliders())